import PropTypes from 'prop-types';
import './AdminPageHeader.css';

// 관리자 화면 상단 제목과 건수 표시. count가 없으면(불러오는 중 등) 건수를 숨긴다.
export default function AdminPageHeader({ title, count }) {
    return (
        <header className="admin-page-header">
            <h1>{title}</h1>
            {typeof count === 'number' && <span className="admin-page-count">총 {count.toLocaleString()}건</span>}
        </header>
    );
}

AdminPageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    count: PropTypes.number,
};
